/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { BackfillRequestBuilderRequestsMetadata, type BackfillRequestBuilder } from './backfill/index.js';
// @ts-ignore
import { CheckoutRequestBuilderRequestsMetadata, type CheckoutRequestBuilder } from './checkout/index.js';
// @ts-ignore
import { CheckoutPageRequestBuilderRequestsMetadata, type CheckoutPageRequestBuilder } from './checkoutPage/index.js';
// @ts-ignore
import { CreatedRequestBuilderRequestsMetadata, type CreatedRequestBuilder } from './created/index.js';
// @ts-ignore
import { EntitlementsRequestBuilderRequestsMetadata, type EntitlementsRequestBuilder } from './entitlements/index.js';
// @ts-ignore
import { InvoicesRequestBuilderNavigationMetadata, InvoicesRequestBuilderRequestsMetadata, type InvoicesRequestBuilder } from './invoices/index.js';
// @ts-ignore
import { ItemsRequestBuilderRequestsMetadata, type ItemsRequestBuilder } from './items/index.js';
// @ts-ignore
import { PlansRequestBuilderRequestsMetadata, type PlansRequestBuilder } from './plans/index.js';
// @ts-ignore
import { PortalSessionLinkRequestBuilderRequestsMetadata, type PortalSessionLinkRequestBuilder } from './portalSessionLink/index.js';
// @ts-ignore
import { SeatsRequestBuilderRequestsMetadata, type SeatsRequestBuilder } from './seats/index.js';
// @ts-ignore
import { StripeWebhookRequestBuilderRequestsMetadata, type StripeWebhookRequestBuilder } from './stripeWebhook/index.js';
// @ts-ignore
import { type WebhookRequestBuilder, WebhookRequestBuilderRequestsMetadata } from './webhook/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/subscriptions
 */
export interface SubscriptionsRequestBuilder extends BaseRequestBuilder<SubscriptionsRequestBuilder> {
    /**
     * The backfill property
     */
    get backfill(): BackfillRequestBuilder;
    /**
     * The checkout property
     */
    get checkout(): CheckoutRequestBuilder;
    /**
     * The checkoutPage property
     */
    get checkoutPage(): CheckoutPageRequestBuilder;
    /**
     * The created property
     */
    get created(): CreatedRequestBuilder;
    /**
     * The entitlements property
     */
    get entitlements(): EntitlementsRequestBuilder;
    /**
     * The invoices property
     */
    get invoices(): InvoicesRequestBuilder;
    /**
     * The items property
     */
    get items(): ItemsRequestBuilder;
    /**
     * The plans property
     */
    get plans(): PlansRequestBuilder;
    /**
     * The portalSessionLink property
     */
    get portalSessionLink(): PortalSessionLinkRequestBuilder;
    /**
     * The seats property
     */
    get seats(): SeatsRequestBuilder;
    /**
     * The stripeWebhook property
     */
    get stripeWebhook(): StripeWebhookRequestBuilder;
    /**
     * The webhook property
     */
    get webhook(): WebhookRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const SubscriptionsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/subscriptions";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SubscriptionsRequestBuilderNavigationMetadata: Record<Exclude<keyof SubscriptionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    backfill: {
        requestsMetadata: BackfillRequestBuilderRequestsMetadata,
    },
    checkout: {
        requestsMetadata: CheckoutRequestBuilderRequestsMetadata,
    },
    checkoutPage: {
        requestsMetadata: CheckoutPageRequestBuilderRequestsMetadata,
    },
    created: {
        requestsMetadata: CreatedRequestBuilderRequestsMetadata,
    },
    entitlements: {
        requestsMetadata: EntitlementsRequestBuilderRequestsMetadata,
    },
    invoices: {
        requestsMetadata: InvoicesRequestBuilderRequestsMetadata,
        navigationMetadata: InvoicesRequestBuilderNavigationMetadata,
    },
    items: {
        requestsMetadata: ItemsRequestBuilderRequestsMetadata,
    },
    plans: {
        requestsMetadata: PlansRequestBuilderRequestsMetadata,
    },
    portalSessionLink: {
        requestsMetadata: PortalSessionLinkRequestBuilderRequestsMetadata,
    },
    seats: {
        requestsMetadata: SeatsRequestBuilderRequestsMetadata,
    },
    stripeWebhook: {
        requestsMetadata: StripeWebhookRequestBuilderRequestsMetadata,
    },
    webhook: {
        requestsMetadata: WebhookRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
